import api from "./axios";
import { fetchAndDownload } from "../utils/exportCsv";

export const listTaskMasters = (params = {}) => api.get("/task-masters", { params });
export const getTaskMaster = (id) => api.get(`/task-masters/${id}`);
export const createTaskMaster = (payload) => api.post("/task-masters", payload);
export const updateTaskMaster = (id, payload) => api.put(`/task-masters/${id}`, payload);
export const deleteTaskMaster = (id) => api.delete(`/task-masters/${id}`);

// Dev-gated: round-trip export + bulk import.
export const exportTaskMasters = () =>
  fetchAndDownload("/task-masters/export", {}, "task-masters");
export const bulkImportTaskMasters = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/task-masters/bulk-import", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
